import {
    FaTwitterSquare,
    FaFacebookSquare,
    FaPhoneSquareAlt,
    FaInstagramSquare,
  } from "react-icons/fa"
  import logo from '../../images/footer.png'

const FooterComponent = ({location}) => {

 
    return ( 

        <footer className={location !== '/validacion/' ? "footer-ss d-none d-lg-block" : "footer-ss "}>
        <div className="contenedor ">
            <div  className="d-flex">
                <div>
                    <img src={logo} alt={"Logo SuperIntendencia de Salud"} className="imagen-footer"/>
                </div>
                <div className="ml-auto">
                    <a href="tel:6008369000" className="font-weight-bold my-1 d-block" style={{color: '#b7b3b3'}}><FaPhoneSquareAlt  className="mx-2 mt-1 icon-footer-ss" />600 836 9000</a>
                    <a href="https://twitter.com/SuperDeSalud" rel="noopener noreferrer" target="_blank" className="font-weight-bold my-1 d-block" style={{color: '#b7b3b3'}}><FaTwitterSquare  className="mx-2 mt-1 icon-footer-ss" />@SuperDeSalud </a>
                </div>
                <div className="ml-auto">
                    <a href="https://www.instagram.com/superdesaludchile/ " rel="noopener noreferrer" target="_blank" style={{color: '#b7b3b3'}} className="font-weight-bold my-1 d-block"><FaInstagramSquare  className="mx-2 mt-1 icon-footer-ss" />@SuperdeSaludChile</a>
                    <a href="https://www.facebook.com/SuperdeSaludChile " rel="noopener noreferrer" target="_blank" style={{color: '#b7b3b3'}} className="font-weight-bold my-1 d-block"><FaFacebookSquare  className="mx-2 mt-1 icon-footer-ss" />@SuperdeSaludChile</a>
                </div>
            </div>
        </div>
    </footer>

     );
}
 
export default FooterComponent;